var styles = {
  "Outer": "Polaris-Tabs__Outer",
  "Wrapper": "Polaris-Tabs__Wrapper",
  "WrapperWithNewButton": "Polaris-Tabs__WrapperWithNewButton",
  "ButtonWrapper": "Polaris-Tabs__ButtonWrapper",
  "Tabs": "Polaris-Tabs",
  "Tab": "Polaris-Tabs__Tab",
  "Tab-active": "Polaris-Tabs__Tab--active",
  "Tab-hasActions": "Polaris-Tabs__Tab--hasActions",
  "Tab-iconOnly": "Polaris-Tabs__Tab--iconOnly",
  "fillSpace": "Polaris-Tabs--fillSpace",
  "TabContainer": "Polaris-Tabs__TabContainer",
  "fitted": "Polaris-Tabs--fitted",
  "titleWithIcon": "Polaris-Tabs--titleWithIcon",
  "List": "Polaris-Tabs__List",
  "Item": "Polaris-Tabs__Item",
  "DisclosureTab": "Polaris-Tabs__DisclosureTab",
  "DisclosureTab-visible": "Polaris-Tabs__DisclosureTab--visible",
  "DisclosureActivator": "Polaris-Tabs__DisclosureActivator",
  "TabsMeasurer": "Polaris-Tabs__TabsMeasurer",
  "NewTab": "Polaris-Tabs__NewTab",
  "ActionListWrap": "Polaris-Tabs__ActionListWrap",
  "Panel": "Polaris-Tabs__Panel",
  "Panel-hidden": "Polaris-Tabs__Panel--hidden"
};

export { styles as default };
